<template>
  <div class="relative flex">
    <template v-if="config?.deviceFamilly?.this_det_id == 50">
      <WatchCam :config="config" />
    </template>

    <template v-if="config?.deviceFamilly?.this_det_id == 55">
      <Drone_Externe :config="config" />
    </template>

    <!-- <Device_Link
      v-if="
        $root.user.can([4, 5], 'DEVICES.EDIT.edit_device') &&
        !$root.isMilestonePlugin
      "
      :dev_id="config?.deviceFamilly?.this_dev_id"
      CssClass="right-[10px]"
    /> -->
  </div>
</template>

<script>
import Drone_Externe from "@/partials/Device/Template/Drone_Externe/Drone_Externe.tmp.vue";
import WatchCam from "@/partials/Device/Template/WatchCam/WatchCam.tmp.vue";
import Device_Link from "@/partials/Device/Template/Device_Link.vue";

export default {
  name: "Device_Info_Externe",
  components: {
    Drone_Externe,
    WatchCam,
    Device_Link,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>
